'use strict';

function _EditHousing() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [EditData, _ErrorController];
  this._analytics = new Analytics();
  this._dataSanitization = new DataSanitization();

  this.init = function () {
    this._super();

    $('.js-editData__edit-icon', this.node).on('click.editSection', this.onEditSection.bind(this, null));
  };

  this.initAllReady = function () {
    this._super();

    // this Page component is loaded inline via Pug, and is used on 2 diff pages...
    // in the case when page A redirects to page B, we have timing issues with init and destroy of the same component...
    // so this guard prevents running things twice
    var housingForm = $('[data-mogo-page="_EditHousing"]');
    if (housingForm.length === 1) {
      this._editHousingCallback = this.presenter.addCallbackToAction('account.edit_housing_info', $.proxy(this._onEditHousing, this));

      $('.js-cancel', this.node).on('click', $.proxy(this.cancelEdits, this, 'account', null));

      // this._createTooltip();
      this._addComputedVariables();
      this._extendViewMap();

      $(this.node).show();
    }
  };

  this._onLoadPartial = function () {};

  // this._createTooltip = function(){
  //   $('.js-editData-housingTooltip').mogo().create('ToolTip', {
  //     "targetElementId": "housing-info",
  //     "center": true,
  //     "hover": true,
  //     "closeIcon": false
  //   });
  // };

  this._addComputedVariables = function () {
    this.presenter.extendCustomValidations('account.edit_housing_info', {
      residential_monthly_cost: {
        sanitize: this._dataSanitization.sanitizeMoney
      }
    });
  };

  this._extendViewMap = function () {
    var viewMap = {
      'account.residential_monthly_cost': {
        set: this._dataSanitization.sanitizeMoney
      }
    };
    this.presenter.extendViewMap(viewMap);
  };

  this._onEditHousing = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage($('#editHousingInfo')[0], { productLabel: 'MogoMember' });
    } else if (response == 200) {
      var formAnalyticsID = $('#editHousingInfo').data('analytics-id');
      this._analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.models.account.updateModel(data);
      this.presenter.updateDOM(this.node);

      var isReviewPage = $('#loanOfferReupReview').length > 0;
      if (isReviewPage) {
        this.closeSection();
        $('#loanOfferReupReview').mogo().stopEditingMode();
      }
    } else if (data.errors) {
      // @TODO test
      $('form', this.node).mogo().parseErrorObject(data.errors);
    }
  };

  this.destroy = function () {
    this.presenter.removeCallbackFromAction('account.edit_housing_info', this._editHousingCallback);
    $('.js-cancel', this.node).off('click', $.proxy(this.cancelEdits, this));
    $('.js-editData__edit-icon', this.node).off('click.editSection');
  };
}